import React from 'react'
import { TableHeaderData } from '../investorOverview/types'
import { TableCell, TableRow, Theme, Typography, useTheme } from '@mui/material'
import { NotReqIcon, ReqIcon } from '../../assets/SvgIcons'

export const nioTableHeaders: TableHeaderData[] = [
    {
        id: "clientCategory",
        label: "Client Category",
        align: "left",
        isSortable: false
    },
    {
        id: "accountopening",
        label: "Account Opening Form (AOF)",
        align: "center",
        isSortable: false
    },
    {
        id: "kycstatus",
        label: "KYC Status- Registered",
        align: "center",
        isSortable: false
    },
    {
        id: "cancelledCheque",
        label: "Cancelled Cheque",
        align: "center",
        isSortable: false
    },
    {
        id: "fatca",
        label: "FATCA & UBO (non-listed)/SMO (listed)",
        align: "center",
        isSortable: false
    },
    {
        id: "pan",
        label: "PAN",
        align: "center",
        isSortable: false
    },
    {
        id: "board",
        label: "Board Resolution(BR) & Authorized Signatory List(ASL)",
        align: "center",
        isSortable: false
    },
    {
        id: "others",
        label: "Others",
        align: "center",
        isSortable: false
    },
]
export default function NIOTable({ tableBodyData }: { tableBodyData: any }): JSX.Element {
    const theme = useTheme()
    return (
        <>
            {tableBodyData?.map((obj: any, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                backgroundColor: theme.palette.primary[200],
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="overline_400"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                    fontWeight:600
                                })}
                            >
                                {obj?.clientCategory}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                })}
                            >
                                {obj?.accountopening ? <ReqIcon /> : <NotReqIcon />}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.kycstatus ? <ReqIcon /> : <NotReqIcon />}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.cancelledCheque ? <ReqIcon /> : <NotReqIcon />}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.fatca ? <ReqIcon /> : <NotReqIcon />}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.pan ? <ReqIcon /> : <NotReqIcon />}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.board ? <ReqIcon /> : <NotReqIcon />}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="overline_400"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.primary[900],
                                    fontWeight:600
                                })}
                            >
                                {obj?.others}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

